





























































import { ClientAccountsApi } from '@/api/client-accounts';
import editNoteDialog from '@/components/client/view-client/edit-note-dialog.vue';
import { ClientAccount } from '@/shared/clients/client-account';
import { ClientAccountNote } from '@/shared/clients/client-account-note';
import { User } from '@/shared/user';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('user');
const usersModule = namespace('users');
const clientApi = new ClientAccountsApi();

@Component({
    components: {
        editNoteDialog,
    },
})
export default class ClientNotes extends Vue {
    @userModule.Getter('isAdministrator') private isAdministrator!: boolean;
    @userModule.Getter('isHeadOfCustomerExperienceTeam') private isHeadOfCustomerExperienceTeam!: boolean;

    @usersModule.Getter('users') private users!: Array<User>;

    @Prop({ required: true }) private client!: ClientAccount;
    @Prop({ required: true }) private notes!: Array<ClientAccountNote>;

    private editNoteDialogVisible: boolean = false;
    private deleteNoteDialogVisible: boolean = false;
    private selectedNote: ClientAccountNote | null = null;

    private userName(userId: string | null): string {
        const user = this.users.find((u) => u.id === userId);
        return user == null ? userId! : `${user.firstName == null ? '' : user.firstName.trim()} ${user.lastName == null ? '' : user.lastName.trim()}`.trim();
    }

    private showEditNoteDialog(note: ClientAccountNote): void {
        this.selectedNote = { ...note };
        this.editNoteDialogVisible = true;
    }

    private showDeleteNoteDialog(note: ClientAccountNote): void {
        this.selectedNote = { ...note };
        this.deleteNoteDialogVisible = true;
    }

    private onEdit(): void {
        this.$emit('note-updated', { ...this.selectedNote! });
        this.onCancel();
    }

    private async onDelete(): Promise<void> {
        try {
            await clientApi.deleteClientNoteAsync(this.client.id!, this.selectedNote!);
            this.$emit('note-deleted', { ...this.selectedNote! });
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: 'Could not delete client note, please try again.', type: 'is-danger' });
            }
        }

        this.onCancel();
    }

    private onCancel(): void {
        this.editNoteDialogVisible = false;
        this.deleteNoteDialogVisible = false;
    }
}
